import React from "react";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TertiaryButton from "../../Buttons/TertiaryButton";
import PopupHeader from "../PopupHeader";
import useConfirmationPopupData from "./useConfirmationPopupData";

const ConfirmationPopup = ({ popupData, closePopup }) => {
  const { title, prompt, confirmationTitle, cancelTitle, handleOnConfirm } =
    useConfirmationPopupData({
      popupData,
      closePopup,
    });

  return (
    <>
      <PopupHeader headerTitle={title} closePopup={closePopup} />
      <div className="p-5" style={{ width: "400px" }}>
        <div className="my-2">
          <p className="text-center">{prompt}</p>
        </div>

        <div className="flex mt-6 justify-center">
          <PrimaryButton
            title={confirmationTitle}
            border="primaryGreen"
            onClick={handleOnConfirm}
          />
          <div className="ml-2">
            <TertiaryButton
              title={cancelTitle}
              border="primaryGreen"
              onClick={closePopup}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationPopup;
